module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBbaIe17AAAARElEQVQ4y2P4jwQ+MAww7wADDNgPPI8f6KYDg4gHAoOBx8D8n4GBf3Dw+P9AiEHCY7D/Pzh4wHSD5LIB5w2WPD14yjoAG7zaFV1faTQAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDgtMTNUMTU6Mjc6MDgrMDk6MDAQgurLAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDEzLTEwLTA4VDA2OjA4OjIyKzA5OjAwP6gozQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h10/tag36_10_01241_100x100.png
// module id = S2MC
// module chunks = 0